<template>
  <div class="brand">
    <div class="content">
      <div class="title wow fadeInUp">
        {{ $t("about").brand.text0 }}
      </div>
      <div class="allBrand wow fadeInUp">
        <!-- <swiper :options="swiperOption" ref="mySwipers2" class="swiper2">
          <swiper-slide
            class="item"
            v-for="(item, index) in brand"
            :key="index"
          >
            <div class="pic">
              <img :src="`http://www.icoolglobal.cn/${item.picurl}`" alt="" />
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination"></div> -->
        <div class="img">
          <img src="../asset/aike/about1111.jpg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "brand",
  data() {
    return {
      bList: [
        {
          img: require("../asset/aike/brand.png"),
        },
        {
          img: require("../asset/aike/b2.png"),
        },
        {
          img: require("../asset/aike/b3.png"),
        },
        {
          img: require("../asset/aike/b4.png"),
        },
        {
          img: require("../asset/aike/b5.png"),
        },
        {
          img: require("../asset/aike/b6.png"),
        },
        {
          img: require("../asset/aike/b7.png"),
        },
        {
          img: require("../asset/aike/b8.png"),
        },
        {
          img: require("../asset/aike/b9.png"),
        },
        {
          img: require("../asset/aike/b10.png"),
        },
      ],
      swiperOption: {
        slidesPerView: 3, //一行显示3个
        slidesPerColumn: 3, //显示2行
        slidesPerColumnFill: "row",
        init: false,
        spaceBetween: 20,
        loop: false,
        speed: 1000,
        pagination: {
          el: ".swiper-pagination",
          clickable:true
        },
        breakpoints: {
          1000: {
            //当屏幕宽度大于等于1280
            slidesPerView: 1, //一行显示3个
            slidesPerColumn: 2, //显示2行
            slidesPerColumnFill: "row",
            spaceBetween: 10,
          },
        },
      },
    };
  },
  props: ["brand"],
  components: {
    swiper,
    swiperSlide,
  },
  mounted() {
    setTimeout(() => {
      this.$refs.mySwipers2.swiper.init();
    }, 100);
  },
};
</script>

<style lang="scss" scoped>
.brand {
  width: 100%;
  position: relative;
  padding: 80px 0;
  .content {
    width: 80%;
    margin: 0 auto;
    .title {
      color: #343434;
      font-size: 38px;
      font-family: "SOURCEHANSANSCN-MEDIUM";
      text-align: center;
      animation-duration: 2s;
    }
    .allBrand {
      width: 100%;
      margin: 60px auto;
      position: relative;
      animation-duration: 2s;
      .img {
        width: 100%;
        img {
          display: block;
          width: 100%;
        }
      }
      .swiper2 {
        width: 100%;
        .item {
          cursor: pointer;
          padding: 10px 0;
          .pic {
            width: 90%;
            padding: 30px 0;
            margin: 0 auto;
            //  border:1px solid rgba(220,220,220,1);
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 64px;
            justify-content: center;
            img {
              //  max-width: 90%;
              // width: 35%;
              height: 50px;
              object-fit: contain;
              transition: all 600ms;
            }
            &:hover {
              img {
                transform: scale(1.05);
              }
            }
          }
        }
        .item:nth-child(1) {
          .pic {
            img {
              height: 60px;
            }
          }
        }
        .item:nth-child(3) {
          .pic {
            img {
              height: 40px;
            }
          }
        }
        .item:nth-child(4) {
          .pic {
            img {
              height: 80px;
            }
          }
        }
        .item:nth-child(7) {
          .pic {
            img {
              height: 40px;
            }
          }
        }
        .item:nth-child(9) {
          .pic {
            img {
              height: 60px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1000px) {
    padding: 30px 0;
    .content {
      width: 90%;
      .title {
        font-size: 24px;
      }
      .allBrand {
        margin: 30px auto;
        .swiper2 {
          .item {
            .pic {
              padding: 10px 0;
            }
          }
        }
      }
    }
  }
}
</style>
<style>
.swiper-scrollbar {
  height: 2px !important;
  position: absolute;
  left: 0;
  bottom: 120px;
  width: 100%;
  cursor: pointer;
}
.swiper-scrollbar-drag {
  background-color: #0c4ea2;
}
.swiper-pagination{
    display: none;
}
@media screen and (max-width:1000px) {
    .swiper-pagination{
        display: block;
        left: 50%;
        transform: translateX(-50%);
    }
    .swiper-pagination-bullet{
        margin: 0 5px;
    }
}
</style>
